/**
 * let scripts = "window.localStorage.setItem('device', 'ios-\(devType)');" // swift code
 *
 * on react to check whether the device is ios or android,
 * get localStorage 'device' value, if it contains 'ios' then it is ios.
 */

export function logoutIOS() {
  window.webkit.messageHandlers.bridge.postMessage("requestLogout");
}
export function openUrlInSafari(url) {
  window.webkit.messageHandlers.bridge.postMessage(`openUrlInSafari||${url}`);
}

export function downloadBase64(base64) {
  window.webkit.messageHandlers.bridge.postMessage(`downloadBase64||${base64}`);
}

export function downloadImageUrl(url) {
  window.webkit.messageHandlers.bridge.postMessage(`downloadImageUrl||${url}`);
}
